import * as PropTypes from 'prop-types'

const ConnectionShape = PropTypes.shape({

})

export { ConnectionShape }
